import { Route } from "react-router-dom";
import AppSections from "../utils/AppSections";
import ProtectedRoute from "./ProtectedRoute";
import Clients from "../ui/clients_sso/ClientsSSO";
import ClientsList from "../ui/clients_sso/ClientsSSOList";
import ClientsSSOList from "../ui/clients_sso/ClientsSSOList";
import ClientsSSODetails from "../ui/clients_sso/ClientsSSODetails";
import ClientsSSOAddEdit from "../ui/clients_sso/ClientsSSOAddEdit";
//import PilotAddEdit from "../ui/pilots/PilotAddEdit";
//import PilotDetails from "../ui/pilots/PilotDetails";

const ClientsRoutes = (
  <Route
    path={AppSections.CLIENTS}
    element={
      <ProtectedRoute>
        <Clients />
      </ProtectedRoute>
    }
  >
    <Route path="/clients/" element={<ClientsSSOList />} />
    <Route path=":id/view" element={<ClientsSSODetails />} />
    <Route path="create" element={<ClientsSSOAddEdit />} />
    <Route path=":id/edit" element={<ClientsSSOAddEdit />} />
  </Route>
);

export default ClientsRoutes;
